import { CoreUtils } from "@lib/common";
import * as React from "react";
export class LogoRender extends React.Component {
    render() {
        const { image, transformations, hideNotFound } = this.props;
        let logoSrc;
        if (image && image._id) {
            logoSrc = CoreUtils.image.uc(image, transformations);
        }
        return (React.createElement("div", null,
            logoSrc && (React.createElement("img", { src: logoSrc, style: { maxHeight: "75px" } })),
            !logoSrc && !hideNotFound && (React.createElement("div", { className: "width200" },
                React.createElement("div", { className: "font-bold m-tb-5 text-center" },
                    React.createElement("p", { className: "line-height-lg" }, "LOGO"),
                    React.createElement("p", { className: "line-height-lg" }, "NOT FOUND!"))))));
    }
}
//# sourceMappingURL=index.js.map